/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelShiftCoverRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {CancelShiftCoverResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const cancelShiftCover = (request: CancelShiftCoverRequest, options?: CashRequestOptions) => post<CancelShiftCoverRequest, CancelShiftCoverResponse>("/2.0/cash/cancel-shift-cover", request, {...options, rejectOnError: true })